// Single group registry: insertion order is the display order, values name the
// heading message; a server namespace missing here appends after, heading = raw key.
export const VARIABLE_GROUP_MESSAGE_KEYS = {
  player: 'groupPlayer',
  assessment: 'groupAssessment',
  ageGroup: 'groupAgeGroup',
  assessmentSession: 'groupSession'
} as const;

export const VARIABLE_GROUP_ORDER: string[] = Object.keys(VARIABLE_GROUP_MESSAGE_KEYS);
